import Swal from "sweetalert2";

// Iconos de ayuda: <i class="ayuda" data-ayuda="clave"></i> abre un modal con el texto.
// Reemplaza a los tooltips, que en celular quedaban pegados hasta volver a tocar el icono.
export const Ayuda = {
  /**
   * @param {Record<string, {titulo: string, html: string}>} textos  contenido por clave
   */
  bind(textos) {
    document.querySelectorAll("[data-ayuda]").forEach((el) => {
      const ayuda = textos[el.dataset.ayuda];
      if (!ayuda) return;
      el.setAttribute("role", "button");
      el.setAttribute("aria-label", "Ayuda: " + ayuda.titulo);
      el.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        Swal.fire({
          icon: "info",
          title: ayuda.titulo,
          html: '<div class="text-start">' + ayuda.html + "</div>",
          confirmButtonText: "Entendido",
        });
      });
    });
  },
};
